import { MDCIconButtonToggle } from '@material/icon-button'

export default {
  setup() {
    this.iconButtonToggle = new MDCIconButtonToggle(this.el)
  },
  destroy() {
    this.iconButtonToggle?.destroy()
    this.iconButtonToggle = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
